import { ref } from 'vue'

export default function (step: number) {
    const loadedDataCount = ref(0)
    const loadedDataCountStep = ref(step)

    function updateLoadedDataCount () {
        loadedDataCount.value += loadedDataCountStep.value
    }

    return {
        loadedDataCount,
        loadedDataCountStep,
        updateLoadedDataCount
    }
}
